import { createRoot } from 'react-dom/client';
import './index.css';
import { App } from './app';
import './translations/i18n.ts';

const root = createRoot(document.getElementById('app')!);
root.render(<App />);
